export const manifest = {
  screens: {
    scr_7nr492: { name: "Home", route: "/" },
  },
}
